// import { ModeToggle } from '@/components/ui/mode-toggle'
import { UserDropdown } from '@/components/ui/user-dropdown'
import { HeaderBranding } from '@/components/ui/header-branding'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { Badge } from '@/components/ui/badge'
import { useAuth } from '@/contexts/AuthContext'
import { useUserPlan } from '@/contexts/UserPlanContext'
import { Link } from 'react-router-dom'
import { LogIn, Sparkles } from 'lucide-react'

export const AppHeader = () => {
  const { isAuthenticated, isLoading } = useAuth()
  const {
    isFreePlan,
    planDisplayName,
    isLoading: isPlanLoading,
  } = useUserPlan()

  return (
    <header
      className="fixed top-0 left-0 z-50 flex flex-col w-full
     shrink-0 bg-background/10 backdrop-blur-lg transition-opacity 
     duration-200 ease-in-out shadow-2xs"
    >
      {/* Main header with title, user dropdown menu and mode toggle */}
      <div className="flex items-center gap-2 h-18 py-4">
        <div className="container mx-auto flex w-full items-center gap-1 px-4 lg:gap-2 max-w-[1600px]">
          <HeaderBranding />
          <div className="flex items-center gap-2 ml-auto">
            {isLoading ? (
              <Skeleton className="h-9 w-24 rounded-md" />
            ) : isAuthenticated ? (
              <>
                {!isPlanLoading && isFreePlan && (
                  <Button
                    asChild
                    variant="outline"
                    size="sm"
                    className="cursor-pointer h-auto py-1.5"
                  >
                    <Link to="/pricing" className="flex items-center gap-2">
                      <Sparkles className="h-4 w-4 text-primary fill-primary" />
                      <span className="gradient-text font-medium text-sm leading-tight">
                        Upgrade Plan
                      </span>
                    </Link>
                  </Button>
                )}
                {/* Show current plan badge */}
                {!isPlanLoading && !isFreePlan && planDisplayName && (
                  <Badge variant="secondary" className="hidden sm:flex">
                    <span className="text-primary font-bold">
                      {planDisplayName}
                    </span>
                  </Badge>
                )}
                <UserDropdown />
              </>
            ) : (
              <Button
                asChild
                variant="default"
                size="sm"
                className="cursor-pointer"
              >
                <Link to="/auth/signin">
                  <LogIn className="h-4 w-4 mr-2" />
                  Sign In
                </Link>
              </Button>
            )}
            {/* <ModeToggle /> */}
          </div>
        </div>
      </div>
    </header>
  )
}
